import { ConfigObj } from '../../utils'

/*

 -- Example HTML (min options)

    <div class="ps-custom-range-slider"
        data-js-module="custom-range-slider"
        data-range-slider-default-value="0"
        data-range-slider-label-max-text="100 card"
        data-range-slider-label-min-text="0"
        data-range-slider-tooltip-format-string="{0}%"
        data-range-slider-tooltip = true,
        data-range-slider-progress: true,
        data-range-slider-labels: true,
        data-range-slider-progress-color1: '#0C99D9',
        data-range-slider-progress-color2: '#9c9e9f'
        >
        @Html.SliderFor(m => m.Form.PgSwitcherMonthlyRevenueOnlinePercentage,
            new
            {
                @class = "ps-custom-range-input",
                title = "",
                min = "0",
                max = "100",
                step = "1",
                aria_controls = "range-slider__tooltip range-slider__label",
                aria_live = "polite"
            })
    </div>

 */
const _defaultOpts = {
  defaultValue: '0%',
  labelMaxText: '100%',
  labelMinText: '0%',
  tooltipFormatString: '{0}%',
  tooltip: true,
  progress: true,
  labels: true,
  progresscolor1: '#E60975',
  progresscolor2: '#F5F5F5',
}

export default class CustomRangeSlider {
  constructor($el, opts) {
    this.$el = $el
    this.$range = this.$el.querySelector('input[type="range"]')
    this.opts = ConfigObj.merge(_defaultOpts, opts)
  }

  init() {
    // Create Tooltip
    if (this.opts.tooltip === true) {
      this.$tooltip = this.createTooltip()
      this.$el.appendChild(this.$tooltip)
    }

    // Create Label
    if (this.opts.tooltip === true) {
      this.$createLabel = this.createLabel()
      this.$el.appendChild(this.$createLabel)
    }

    // Set the value to zero if it's not explicitly set
    if (!this.$range.getAttribute('value')) this.$range.value = 0

    this.addEventListeners()
    this.update()
  }


  addEventListeners() {
    // Listen input and change events.
    this.$range.addEventListener('input', this.update.bind(this))
    this.$range.addEventListener('change', this.update.bind(this))

    if (this.opts.tooltip) {
      // Window resize
      let fireOnceOnResize = undefined

      window.addEventListener('resize', function () {

        clearTimeout(fireOnceOnResize)
        fireOnceOnResize = setTimeout(this.update.bind(this), 500)

      }.bind(this))
    }
  }


  update() {
    // Get current percentage
    const currentPercentage = this.getPositionByPercentage()

    // Update Tooltip
    if (this.opts.tooltip)
      this.updateTooltip(currentPercentage)

    // Update Progress
    if (this.opts.progress)
      this.updateProgress(currentPercentage)
  }


  createTooltip() {
    // Tooltip Container
    const $tooltip = document.createElement('span')
    $tooltip.classList.add('ps-custom-range-slider__tooltip')
    // Set Initial value
    $tooltip.innerText = this.formatTooltipValue(this.opts.defaultValue)
    // Return Tooltip
    return $tooltip
  }


  updateTooltip(currentPercentage) {
    // Update Value
    this.$tooltip.innerText = this.formatTooltipValue(this.$range.value)
    // Update Position
    this.$tooltip.style.left = `${currentPercentage - (currentPercentage * .06)}%`
  }


  formatTooltipValue(val) {
    return this.opts.tooltipFormatString.replace('{0}', val)
  }


  updateProgress(currentPercentage) {
    const { progresscolor1, progresscolor2 } = this.opts
    // Generate gradient background
    const rangeBg = `linear-gradient(to right,  ${progresscolor1} 0%, ${progresscolor1} ${currentPercentage}%, ${progresscolor2} ${currentPercentage}%, ${progresscolor2} 100%)`
    // Generate cross browser CSS rule
    let cssRule = `#${this.$range.id}::-webkit-slider-runnable-track { background : ${rangeBg}; } `
    cssRule += `#${this.$range.id}::-moz-range-track { background : ${rangeBg}; } `
    cssRule += `#${this.$range.id}::-ms-track { background : ${rangeBg}; } `
    // Push style to head
    this.applyStyle(cssRule)
  }


  applyStyle(cssRule) {
    // If css style exist, remove it.
    let styleElement = document.getElementById(`style_${this.$range.id}`)
    if (styleElement) document.getElementsByTagName('head')[0].removeChild(styleElement)
    // Create new css rule and add to head section
    styleElement = document.createElement('style')
    styleElement.type = 'text/css'
    styleElement.id = `style_${this.$range.id}`
    styleElement.innerHTML = cssRule

    document.querySelector('head').appendChild(styleElement)
  }


  getPositionByPercentage() {
    // Returns current position of thumb by percentage
    return Math.round(100 * this.$range.value / this.$range.getAttribute('max'))
  }


  getPositionByPixel() {
    // Returns current position of thumb by pixel
    return Math.floor((this.$range.offsetWidth / 100) * this.$range.value)
  }


  createLabel() {
    // Label Wrapper
    const $label = document.createElement('span')
    $label.classList.add('ps-custom-range-slider__label')

    // Label Min
    const $labelMin = document.createElement('span')
    $labelMin.classList.add('ps-custom-range-slider__label-min')
    $labelMin.innerText = this.opts.labelMinText

    // Label Max
    const $labelMax = document.createElement('span')
    $labelMax.classList.add('ps-custom-range-slider__label-max')
    $labelMax.innerText = this.opts.labelMaxText

    // Append min/max labels to label wrapper
    $label.appendChild($labelMin)
    $label.appendChild($labelMax)

    // Return Label
    return $label
  }

}



// WEBPACK FOOTER //
// ./js/self-serve/modules/CustomRangeSlider.js